module.exports = __webpack_public_path__ + "media/images/flags/tv-cb5b0b59c6ca0728ed1d6df2f94d820b.svg";